import { setClass } from '../../helpers/utils';
import './styles.scss';

type LoadingSpinnerProps = { variant?: string };

export const LoadingSpinner = ({ variant = '' }: LoadingSpinnerProps) => {
	const typeVariant = {
		red: 'is-red',
	};
	const isVariant = typeVariant[variant] || '';

	return <div className={setClass(`loading-spinner ${isVariant}`)}></div>;
};
